/*
 * OOO scroll-reveal — cascades elements up as they enter the viewport.
 * Safe by design (skill §10):
 *   - Only marks elements that start BELOW the fold, so above-fold
 *     content is never hidden / never flashes.
 *   - A 3s failsafe reveals everything, so a missed observer can't
 *     leave content stuck invisible.
 *   - Fully skipped when the user prefers reduced motion.
 *
 * Authors opt sections in by adding the class `.ooo-reveal` in markup,
 * OR this script auto-promotes any element with [data-ooo-reveal].
 */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var vh = window.innerHeight || document.documentElement.clientHeight;

    // Auto-promote opt-in nodes that aren't yet hidden, only if below fold.
    var optIn = Array.prototype.slice.call(document.querySelectorAll('[data-ooo-reveal]'));
    optIn.forEach(function (el) {
      if (!el.classList.contains('ooo-reveal') && el.getBoundingClientRect().top > vh * 0.85) {
        el.classList.add('ooo-reveal');
      }
    });

    var targets = Array.prototype.slice.call(document.querySelectorAll('.ooo-reveal'))
      .filter(function (el) {
        // keep only below-fold items; reveal anything already in view now
        if (el.getBoundingClientRect().top <= vh * 0.85) { el.classList.add('is-in'); return false; }
        return true;
      });

    if (!targets.length) return;

    // stagger items within the same parent for a cascade
    targets.forEach(function (el) {
      var idx = 0;
      if (el.parentElement) idx = Array.prototype.indexOf.call(el.parentElement.children, el);
      el.style.setProperty('--ooo-reveal-delay', (Math.min(idx, 6) * 0.07) + 's');
    });

    var revealAll = function () { targets.forEach(function (el) { el.classList.add('is-in'); }); };

    if (!('IntersectionObserver' in window)) { revealAll(); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

    targets.forEach(function (el) { io.observe(el); });

    // Failsafe: never let anything stay hidden.
    setTimeout(revealAll, 3000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
